<template>
  <div class="vLoading border-radius" :class="!$store.state.resLoading ? 'vClose' : ''" :style="'height: calc(' + $GLOBAL.screenHeight + 'px);'" v-loading="$store.state.resLoading" :element-loading-text="$GLOBAL.loadingText"></div>
</template>

<script>
export default {
  name: 'EleLoading',
  data () {
    return {
    }
  },
  // =*=生命函数钩子=*=
  // created 是在模版渲染成html或者模版编译进路由前调用
  // mounted 是在模版已经渲染成html之后调用
  // =*=[keep-alive]=*=
  // activated, deactivated 这两个生命周期函数一定是要在使用了keep-alive组件后才会有的，否则则不存在
  // 页面第一次进入，钩子的触发顺序created -> mounted -> activated
  // 退出时触发deactivated。当再次进入（前进或者后退）时，只触发activated
  // activated 中的逻辑不管是否需要缓存都会进行执行
  created () {
  },
  mounted () {
  },
  activated () {
  },
  // watch 专门负责监听的模块 某些地方有用
  watch: {
  },
  // methods 所有的方法都应该在这个函数里定义，其他地方调用
  methods: {
  },
  // computed 是计算属性 有需要计算的值放这里
  computed: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components2/theme/common/element/EleLoading.vue